import { render, staticRenderFns } from "./SystemEmailHistory.vue?vue&type=template&id=4d8eaf68&scoped=true"
import script from "./SystemEmailHistory.vue?vue&type=script&lang=js"
export * from "./SystemEmailHistory.vue?vue&type=script&lang=js"
import style0 from "./SystemEmailHistory.vue?vue&type=style&index=0&id=4d8eaf68&prod&scoped=true&lang=css"
import style1 from "./SystemEmailHistory.vue?vue&type=style&index=1&id=4d8eaf68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8eaf68",
  null
  
)

export default component.exports